<template>
    <admin-layout>    
        <div class="content" slot="main">
            <div class="content-header">
                <h3>Fields <button type="button" class="btn btn-custom" @click="toogleShowFieldModal">Add New <i class="fa fa-plus"></i></button></h3>
            </div>
            
            <table class="table table-striped">
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Field type</th>
                        <th>Data type</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="item in fieldList">
                        <th class="field-label">
                            <a v-if="item.is_editable" role="button" v-on:click="toogleShowFieldModal(item)">{{item.name}}</a>
                            <span v-else>{{ item.name }}</span>
                            <a class="text-right" role="button" v-if="item.is_editable" v-on:click="removeField(item.id)"><i class="fa fa-trash"></i></a>
                        </th>
                        <td>
                            <span class="label label-info" v-if="item.field_type == 'L'">LEAD</span>
                            <span class="label label-info" v-if="item.field_type == 'C'">CRM</span>
                            <span class="label label-default" v-if="item.field_type == 'calculated'">CALCULATED</span>
                            <span class="label label-default" v-if="item.field_type == 'S'">SYSTEM</span>
                        </td>
                        <td>{{item.data_type.name}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        
        <div slot="modals">
            <field-modal v-if="showFieldModal"
                         :field="field"
                         @close="closeFieldModal"></field-modal>
            
        </div>  
    </admin-layout>   
</template>

<script>
 import Vue from 'vue';
 import {AdminLayout} from 'components/layouts/';
 import {FieldModal} from 'components/modals/';
 
 // Load the full build. 
 var _ = require('lodash');
 
 export default {
     components: { 
         AdminLayout,
         FieldModal
     },
     data () {
         return {
             loading: false,
             
             field: null,
             fieldList: [],
             showFieldModal: false,
         };
     },
     
     created () {
         this.fetchInitialData();
     },
     
     methods: {
         fetchInitialData () {
             this.fetchFields();
         },
         fetchFields () {
             var self = this;
             API.fields.getList()
                .then(function (response) {
                    self.fieldList = response.data;
                });
         },
         toogleShowFieldModal (fieldModel) {
             if (fieldModel !== undefined) {
                 this.field = Vue.leadscorz.deep_clone(fieldModel);
             } else {
                 this.field = { id: '', name: '' };
             }
             this.showFieldModal = true;
         },
         closeFieldModal (refresh) {
             this.field = undefined;
             this.showFieldModal = false;
             
             if (refresh) {
                 this.fetchFields();
             }
         },
         removeField (fieldId) {
             var self = this; 
             var r = confirm("This action will be permanently and it can't be recovered. Are you sure you want to continue?");
             if (r === true) {
                 API.fields.delete(fieldId)
                    .then(function () {
                        self.fetchFields();
                    },
                    (error) => {
                        Vue.toast('The field cannot be deleted', {className: ['et-error']});
                    });
             }
         },
     }
 }
</script>
<style scoped>
 .field-label {
     display: flex;
     justify-content: space-between;
 }
</style>



// WEBPACK FOOTER //
// FieldsSettings.vue?dd8c39a0